import { TariffType } from '../../../@types/model/transformer/tariffs/tariffs';
import { IRootState } from '../../../@types/redux';
import { connect } from 'react-redux';
import TransformerCaptureList from './List';

const mapStateToProps = (state : IRootState) => {
    return {
        session: state.auth.session,
        tariffType: 'lpu' as TariffType,
    };
};

const TransformerCaptureLPUList = connect(
    mapStateToProps,
)(TransformerCaptureList);

export default TransformerCaptureLPUList;
